(function () {
  'use strict';

  angular.module('unit.info').controller('UnitInfoCtrl', UnitInfoCtrl);

  UnitInfoCtrl.$inject = [
    '$stateParams',
    'UnitInfo',
    '$rootScope',
    '$state',
    '$cookieStore',
    '$timeout',
    '$location',
    'localStorageService',
    '$translate',
  ];

  function UnitInfoCtrl(
    $stateParams,
    UnitInfo,
    $rootScope,
    $state,
    $cookieStore,
    $timeout,
    $location,
    localStorageService,
    $translate,
  ) {
    var vm = this;

    vm.formIsNotSent = true;
    vm.prospect = {};
    vm.publicMode = false;
    vm.currencyDefault = '';
    vm.loaderDelayEnded = false;
    vm.blueprintSize = {};
    vm.headerHeight = 50;
    vm.errorSendingData = false;
    var isPriceLevelsEnabled = false;
    vm.priceLevels = [];

    $timeout(function () {
      vm.loaderDelayEnded = true;
    }, 500);

    if ($location.absUrl().indexOf('/public') > 0) {
      vm.publicMode = true;
    }

    if (vm.publicMode && !$rootScope._isNotMobile) {
      vm.headerHeight = 0;
    }

    if ($location.absUrl().indexOf('centrobud') !== -1) {
      isPriceLevelsEnabled = true;
    }

    if (localStorageService.get('prospect')) {
      var cookieProspect = localStorageService.get('prospect');
      if (typeof cookieProspect.name !== 'undefined') {
        vm.prospect.name = cookieProspect.name;
      }
      if (typeof cookieProspect.phone !== 'undefined') {
        vm.prospect.phone = cookieProspect.phone;
      }
    }

    vm.unitId = $stateParams.id;
    $rootScope.unitId = $stateParams.id;

    vm.unit = UnitInfo.get({ id: $stateParams.id }, function () {
      vm.loaded = true;
      isPriceLevelsEnabled ? calculatePriceLevels() : false;
      if (!vm.publicMode) {
        $rootScope.$broadcast('unit.status.changed', {
          id: vm.unitId,
          new_status: vm.unit.status,
          old_status: {},
        });
      }
      vm.currencyDefault = vm.unit.company.currency;
      vm.additionalCurrency = $rootScope.defineAdditionalCurrency(
        vm.unit.company.country_id,
        vm.currencyDefault,
      );
      vm.fromCurrency = vm.unit.current_currency_set;
      vm.toCurrency =
        vm.unit.current_currency_set === vm.unit.company.currency
          ? vm.additionalCurrency
          : vm.unit.company.currency;
    });

    vm.showConversionFormFn = function () {
      vm.showConversionForm = !vm.showConversionForm;
      vm.blueprintSize = {
        width: '80px',
        height: '80px',
        'min-height': '80px',
      };
    };

    vm.closeUnitInfo = function () {
      $state.go('^');
    };

    vm.sendConversionForm = function () {
      if (vm.formIsNotSent) $timeout(vm.sendFn, 0);

      vm.formIsNotSent = false;

      localStorageService.set('prospect', vm.prospect);
    };

    vm.sendFn = function () {
      vm.errorSendingData = false;

      var data = {
        name: vm.prospect.name,
        phone: vm.prospect.phone,
        unit_id: vm.unitId,
      };
      UnitInfo.createProspect(
        data,
        function (response) {
          if (response.message && response.message == 'prospect exist') {
            alert($translate.instant('unit.info.conversion.already.submitted'));
          }
          $('div[data-unit-id="' + vm.unitId + '"]').addClass('-state-send');
        },
        function (response) {
          vm.errorSendingData = true;
        },
      );
    };

    function calculatePriceLevels() {
      var basePrice = {
        pricePerSqm: Math.floor((vm.unit.current_price_set * 1) / 0.88),
        totalCost:
          Math.round(((vm.unit.current_cost_set * 1) / 0.88) * 100) / 100,
      };
      var priceLevels = [
        {
          type: 'level3',
          caption: '100% оплата',
          pricePerSqm: Math.ceil(
            basePrice.pricePerSqm - basePrice.pricePerSqm * 0.12,
          ),
          totalCost:
            Math.round(
              (basePrice.totalCost - basePrice.totalCost * 0.12) * 100,
            ) / 100,
          savingsAmount:
            Math.round(
              (basePrice.totalCost -
                (basePrice.totalCost - basePrice.totalCost * 0.12)) *
                100,
            ) / 100,
          savingsPercent: 12,
        },
        {
          type: 'level2',
          caption: '50% оплата',
          pricePerSqm: Math.ceil(
            basePrice.pricePerSqm - basePrice.pricePerSqm * 0.1,
          ),
          totalCost:
            Math.round(
              (basePrice.totalCost - basePrice.totalCost * 0.1) * 100,
            ) / 100,
          savingsAmount:
            Math.round(
              (basePrice.totalCost -
                (basePrice.totalCost - basePrice.totalCost * 0.1)) *
                100,
            ) / 100,
          savingsPercent: 10,
        },
        {
          type: 'level1',
          caption: '30% оплата',
          pricePerSqm: Math.ceil(
            basePrice.pricePerSqm - basePrice.pricePerSqm * 0.03,
          ),
          totalCost:
            Math.round(
              (basePrice.totalCost - basePrice.totalCost * 0.03) * 100,
            ) / 100,
          savingsAmount:
            Math.round(
              (basePrice.totalCost -
                (basePrice.totalCost - basePrice.totalCost * 0.03)) *
                100,
            ) / 100,
          savingsPercent: 3,
        },
        {
          type: 'base',
          caption: 'Базова',
          pricePerSqm: basePrice.pricePerSqm,
          totalCost: basePrice.totalCost,
          savingsAmount: 0,
          savingsPercent: 0,
        },
      ];
      vm.priceLevels = priceLevels;
    }
  }
})();
